import { useQuery } from '@tanstack/react-query';
import { junip } from 'lib/junip';
import type { JunipProductOverview } from 'types/reviews';
import type {
  JunipProductOverviewItemRaw,
  JunipProductOverviewsRaw,
} from 'types/reviews/rawData';
import { convertKeysToCamelCase } from 'utils/convertKeysToCamelCase';

export const RATINGS_OVERVIEW_KEY = 'ratingsOverview';

export const fetchRatingsOverview = async () => {
  const res = await junip<JunipProductOverviewsRaw>('/v1/product_overviews');
  return convertKeysToCamelCase<
    JunipProductOverviewItemRaw,
    JunipProductOverview
  >(res.product_overviews[0]);
};

export const useRatingsOverview = () =>
  useQuery({
    queryKey: [RATINGS_OVERVIEW_KEY],
    queryFn: fetchRatingsOverview,
  });
